export default {
  ACCESS_TOKEN: 'access_token',
  NOTIFICATION_KEY: 'notifications',
  KEY_CURRENT_USER_ID: 'current_user_id',
  KEY_LANGUAGE: 'constant.language',
  PRICE_COLUMNS_KEY: 'price_columns',
};
